import { Modal, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Input } from "../../Controls/Input";
import { Select } from "../../Controls/Select";
import { Button } from "../../Controls/Button";
import { StaffRole } from "../../Data/ApiTransport";
import { HeaderText } from "../../Controls/HeaderText";
import { DataEntitiesStaff, StaffApi } from "../../shared/api/axios-client";
import { useEffect } from "react";
import { createApiService } from "../../shared/apiConfig";
import { da } from "@faker-js/faker";

interface StaffEditModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    onSave: (data: DataEntitiesStaff, msg: string) => void;
    staff: DataEntitiesStaff | undefined
}
interface StaffEditForm {
    name: string;
    emailAddress: string;
    phoneNumber?: string;
    note?: string;
}
export default function AdminUsersModal({ show, setShow, onSave, staff }: StaffEditModalProps) {
    const staffApi = createApiService(StaffApi)
    const { register, handleSubmit, formState: { errors }, reset, clearErrors } = useForm<StaffEditForm>({

    });

    useEffect(() => {
        reset({
            name: staff?.name || "",
            emailAddress: staff?.emailAddress || "",
            note: staff?.note || "",
            phoneNumber: staff?.phoneNumber || ""
        });
    }, [staff])

    async function submit(data: StaffEditForm) {
        try {
            let result;

            if (staff?.staffId) {
                // Update existing staff
                result = await staffApi.updateStaff({
                    id: staff.staffId,
                    serverRequestsPatchStaffRequest: {
                        ...data
                    }
                });
                onSave(result,'SuperAdmin updated successfully')
            } else {
                // Create new staff
                try {

                    result = await staffApi.createAdminStaff({
                        serverRequestsCreateAdminStaffRequest: {
                            ...data
                        }
                    });
                    onSave(result,'SuperAdmin added successfully')
                } catch {

                }


            }

        } catch (error) {

        } finally {

        }

    }

    return (
        <Modal show={show} centered onHide={() => setShow(false)}>
            <Form onSubmit={handleSubmit(submit)}>
                <Modal.Header closeButton>
                    <HeaderText className="font-semibold">Admin User</HeaderText>
                </Modal.Header>
                <Modal.Body>
                    <Input
                        type="text"
                        label="Admin Name"
                        {...register("name", {
                            required: "Name is required",
                            minLength: {
                                value: 2,
                                message: "Name must be at least 2 characters"
                            }
                        })}
                        error={errors.name}
                    />

                    <Input
                        type="email"
                        label="Email"
                        {...register("emailAddress", {
                            required: "Email is required",
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address"
                            }
                        })}
                        error={errors.emailAddress}
                    />

                    <Input
                        type="text"
                        label="Phone Number (optional)"
                        {...register("phoneNumber", {
                            pattern: {
                                value: /^\d{3}-\d{3}-\d{4}$/,
                                message: "Phone number must be in format ###-###-####"
                            }
                        })}
                        placeholder="555-555-5555"
                        error={errors.phoneNumber} />


                    <Input
                        type="text"
                        label="Note"
                        {...register("note")}
                        error={errors.note}
                    />
                    <div className="d-flex gap-2">
                        <Button className="w-100" onClick={() => setShow(false)}>Cancel</Button>
                        {staff?.staffId ? <Button className="w-100" type="submit">Update</Button> : <Button className="w-100" type="submit">Create</Button>}
                    </div>
                </Modal.Body>
            </Form>
        </Modal>
    );
}